module.exports = "<!-- <div class=\"alert alert-warning alert-dismissible fade show\" role=\"alert\">\r\n    <strong>Holy guacamole!</strong> You should check in on some of those fields below.\r\n    <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div> -->\r\n  <div class=\"col-md-6 col-lg-12 text-left\">\r\n    <span class=\"float-md-left\">Displaying Available Containers</span>\r\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/filter-summary/filter-summary.component.html
// module id = ./src/app/filter-summary/filter-summary.component.html
// module chunks = main